(() => {
  class ProductCard extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.form = this.querySelector('.product-card__hover-action-form');
      this.button = this.form && this.form.querySelector('[data-add-to-cart-btn]');

      if (!this.form || !this.button) return;

      this._onSubmit = this.onSubmit.bind(this);
      this.form.addEventListener('submit', this._onSubmit);
    }

    disconnectedCallback() {
      if (this.form && this._onSubmit) {
        this.form.removeEventListener('submit', this._onSubmit);
      }
    }

    onSubmit() {
      this.handleAjaxCartSubmit();
    }

    handleAjaxCartSubmit() {
      if (this.button.disabled) return;

      var button = this.button;
      var originalText = button.getAttribute('data-default-text') || 'Add to Cart';
      var loadingText = button.getAttribute('data-loading-text') || 'Adding...';
      var attempts = 0;
      var initialItemCount = 0;

      if (window.liquidAjaxCart && typeof window.liquidAjaxCart.getCartState === 'function') {
        var initialState = window.liquidAjaxCart.getCartState();
        if (initialState && initialState.cart && typeof initialState.cart.item_count === 'number') {
          initialItemCount = initialState.cart.item_count;
        }
      }

      button.disabled = true;
      button.textContent = loadingText;

      function finish(success) {
        button.disabled = false;
        if (success) {
          button.textContent = 'Added!';
          setTimeout(function () {
            button.textContent = originalText;
          }, 1500);
        } else {
          button.textContent = originalText;
        }
      }

      function checkCartUpdate() {
        if (!window.liquidAjaxCart || typeof window.liquidAjaxCart.getCartState !== 'function') {
          if (attempts++ < 50) {
            setTimeout(checkCartUpdate, 100);
          } else {
            finish(false);
          }
          return;
        }

        var currentState = window.liquidAjaxCart.getCartState();
        var currentItemCount =
          currentState && currentState.cart && typeof currentState.cart.item_count === 'number'
            ? currentState.cart.item_count
            : 0;

        if (currentItemCount > initialItemCount) {
          finish(true);
          return;
        }

        if (attempts++ < 50) {
          setTimeout(checkCartUpdate, 100);
        } else {
          finish(false);
        }
      }

      setTimeout(checkCartUpdate, 100);
    }
  }

  if (!customElements.get('product-card')) {
    customElements.define('product-card', ProductCard);
  }
})();
